import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Stack } from '@emburse/embark-core';
import { CorpMerchantCodesContext } from './CorpMerchantCodesProvider';
import CorpMerchantCodesHeader from './Components/CorpMerchantCodesHeader';
import CorpMerchantCodesControls from './Components/CorpMerchantCodesControls';
import CorpMerchantCodesDataGrid from './Components/CorpMerchantCodesDataGrid';
import CorpMerchantCodesLoading from './Components/CorpMerchantCodesLoading';
import FourOhFour from '../../views/ErrorPages/404';
import SingleColumnLayout from '../../components/Layouts/SingleColumnLayout';
function CorpMerchantCodes() {
    const { loading, error } = useContext(CorpMerchantCodesContext);
    return (_jsx(SingleColumnLayout, { children: _jsxs(Stack, { alignItems: "center", spacing: 8, sx: { width: '100%' }, children: [!error && _jsx(CorpMerchantCodesHeader, {}), !error && _jsx(CorpMerchantCodesControls, {}), loading && _jsx(CorpMerchantCodesLoading, {}), !loading && !error && _jsx(CorpMerchantCodesDataGrid, {}), !loading && error && _jsx(FourOhFour, {})] }) }));
}
export default CorpMerchantCodes;
